import { CcIcon } from '@utp/components-react';
import React, { useEffect, useRef, useState } from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfDocument from './PdfDocument';
import ExcelDocument from './XlsxDocument';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

interface FileDownloaderProps {
  academicPlan: any;
  data: any;
  fullName: string;
  program: string;
  disabled: boolean;
}

const FileDownloader: React.FC<FileDownloaderProps> = ({
  academicPlan,
  data,
  fullName,
  program,
  disabled
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleOptions = () => {
    GoogleAnalytics.writeLog(
      'portal-course-downloadProgressByCourses',
      'course'
    );
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="curriculum-downloader" ref={menuRef}>
      <a
        href="#"
        className="custom-button"
        onClick={toggleOptions}
        data-testid="download-button"
      >
        <span className="text">Descargar</span>
        <span className="divider" />
        <div className="icon">
          <CcIcon name="chevron-down" size={18} />
        </div>
      </a>

      {isOpen && !disabled && (
        <div
          className="curriculum-downloader-options"
          role="menu"
          tabIndex={-1}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <li>
            <button
              type="button"
              role="menuitem"
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            >
              <PDFDownloadLink
                document={
                  <PdfDocument
                    academicPlan={academicPlan}
                    data={data}
                    fullName={fullName}
                    program={program}
                  />
                }
                fileName="Plan_de_Estudio.pdf"
                className="curriculum-downloader-li"
              >
                Versión en PDF
              </PDFDownloadLink>
            </button>
          </li>
          <li>
            <ExcelDocument data={data} />
          </li>
        </div>
      )}
    </div>
  );
};

export default FileDownloader;
